import React, { useState, useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import FAQ from "../../components/FAQ";
import SupportSec from "../../components/SupportSec";
import useDeviceSize from "../../utils/useDeviceSize";
import { TiFlowChildren, TiFlowMerge } from "react-icons/ti";
import { IoRocketOutline } from "react-icons/io5";
import { BiSelectMultiple } from "react-icons/bi";
import { FiUserCheck } from "react-icons/fi";
import { TbHandClick } from "react-icons/tb";
import { MdOutlineScreenshot, MdOutlineDashboard } from "react-icons/md";
import { AiOutlineDatabase } from "react-icons/ai";
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";
import { BASE_ASSETS_URL } from "../../constants/constants";

const whyReasons = [
  {
    id: 1,
    title: "Streamline Decision-Making with BoloForms Approval",
    desc: "Effortlessly involve multiple team members via email, track progress on BoloForms Dashboard or Google Sheets, and empower each approver to share feedback independently.",
    image: "reason-1.png",
    isImgFirst: true,
  },
  {
    id: 2,
    title: "View all submissions at one place",
    desc: "Streamline data management with BoloForms, a versatile all-in-one hybrid of spreadsheets and databases, giving you full control over how you view and utilize your information.",
    image: "reason-2.gif",
    isImgFirst: false,
  },
  {
    id: 3,
    title: "Ready in Minutes",
    desc: "Craft the ideal approval workflow effortlessly, no coding necessary. BoloForms user-friendly drag-and-drop interface enables you to seamlessly incorporate approvers, emails, and conditional branches into your approval process.",
    image: "reason-3.gif",
    isImgFirst: true,
  },
];

const senderSteps = [
  {
    id: 1,
    title: "Create Form",
    desc: "Start by creating a form or else you can also use the pre existing templates.",
    image: "senderStep-1.gif",
    isImgFirst: true,
  },
  {
    id: 2,
    title: "Workflow and Recipient",
    desc: "Create the workflow and add the email of the recipients.",
    image: "senderStep-2.gif",
    isImgFirst: false,
  },
  {
    id: 3,
    title: "Send the Form",
    desc: "Send the form for approval smoothly to accelerate the authorization process promptly.",
    image: "senderStep-3.gif",
    isImgFirst: true,
  },
];

const receiverSteps = [
  {
    id: 1,
    title: "Make Your Decision",
    desc: 'Choose either "Approve" or "Reject" based on your needs. You can also opt for "Request More Information" if necessary.',
    image: "receiverStep-1.gif",
    isImgFirst: false,
  },
  {
    id: 2,
    title: "Include a Message and Submit",
    desc: "Add a message, then proceed to submit your response.",
    image: "receiverStep-2.gif",
    isImgFirst: true,
  },
];

const features = [
  {
    id: 1,
    icon: <IoRocketOutline />,
    title: "Get Started in Less than 5 Minutes.",
    description:
      "Just use an existing Google Form, add approvers, and we'll notify them via email when submissions are made.",
  },
  {
    id: 2,
    icon: <TiFlowChildren />,
    title: "Multi-Level Workflows",
    description:
      "To ensure that your executives do not approve a document until it has been reviewed and accepted by other employees, you can set up multi-level approval processes.",
  },
  {
    id: 3,
    icon: <BiSelectMultiple />,
    title: "Dynamic Reciepients",
    description:
      "Approvers can be selected based on the answers to a form response or entered manually by the requestor.",
  },
  {
    id: 4,
    icon: <FiUserCheck />,
    title: "Role Based Workflows",
    description:
      "Assign the following roles to your recipients: Approver, Receive a Copy, and Send Final Email Only.",
  },
  {
    id: 5,
    icon: <TiFlowMerge />,
    title: "Conditional Logic",
    description:
      "To prevent unnecessary work for approvers, set logic with your approvals to ensure approvers only receive the requests that are relevant to them.",
  },
  {
    id: 6,
    icon: <TbHandClick />,
    title: "One-Click Approvals",
    description:
      "Notification emails are sent to users and can be approved with a single click.",
  },
  {
    id: 7,
    icon: <MdOutlineScreenshot />,
    title: "Responsive Design",
    description:
      "It is designed to be mobile-first, and seamlessly works on desktop and tablet as well.",
  },
  {
    id: 8,
    icon: <AiOutlineDatabase />,
    title: "Enterprise Grade Security",
    description:
      "Majority of data stored in your spreadsheet. This ensures you have the complete control of your data with end to end encryption.",
  },
  {
    id: 9,
    icon: <MdOutlineDashboard />,
    title: "Custom Dashboard",
    description:
      "Track approvals of various forms from a single place! See the approval process for each request in real-time",
  },
];

const reviews = [
  {
    id: 1,
    name: "Repa Mandala",
    image: "repa.jpeg",
    review:
      "This add on is easy to install and works just amazing. The dashboard has a clean user interface. The app is easy and simple to use. Whenever you need an approval process for any form (from one person or more), this add on is what makes the job.",
  },
  {
    id: 2,
    name: "Alaa Khaled",
    image: "alaa.jpeg",
    review:
      "I like this software so much , super user friendly , A true life saver charging you with no cost , the customer support is super helpful mr paresh help me alot in understanding the software seconds after asking his support . thank you so much wishing you lots of success.",
  },
  {
    id: 3,
    name: "Deepak S (Solero Corporation)",
    image: "deepak.jpeg",
    review:
      "Easy to use interface and timely support...looking for more features",
  },
  {
    id: 4,
    name: "Patrick Nyama",
    image: "patrick.jpeg",
    review:
      "I was having challenges figuring out the right logic for my workflow. I called Paresh not realizing the time difference (it was almost midnight his time). He answered my call and helped me figure it out. The customer support team is super helpful. I will definitely recommend using the BoloForms. Thank you",
  },
  {
    id: 5,
    name: "Raman R",
    image: "raman.jpeg",
    review:
      "We've been using BoloForms for about a month, and it has streamlined our leave request application process. It is simple to set up and track, plus, the one-click approval email makes it much faster to process requests., the customer support is super helpful mr paresh help me alot in understanding the software seconds after asking his support . thank you so much wishing you lots of success.",
  },
  {
    id: 6,
    name: "John M.",
    image: "john.jpeg",
    review:
      "Customer support is super awesome, Great add on for our team! This helps our task management must easier. I can easily keep track of my member's request and work progress. The approval process is smooth and extremely quick. I highly recommend this addon especially for small business like mine.",
  },
];

const faqs = [
  {
    id: 1,
    title: "How to calculate the number of requests based on email quota?",
    desc: "Emails & Requests are different. For examples, if you set up a workflow with 2 recipients, a form respondent submit a request then 2 emails counted to be sent to 2 recipients. In average, a request from our users consists of 4 emails. That is why free plan (500 emails) is calculated to be approximately 125 requests per month. The smaller number of recipient you set up in the workflow, the more request you have with a fixed email quota and vice versa.",
  },
  {
    id: 2,
    title: "Why the addon requires access to my Google Drive?",
    desc: "Permission to Google Drive is only necessary for the addon to perform actions related to your connected Google Form and spreadsheet on your behalf. In no circumstance that we will use those files for any other purposes or sharing to third parties.",
  },
  {
    id: 3,
    title: "How does approval workflow feature work?",
    desc: "When a Form Respondent sends a request, the addon will automatically send approval notification email to your specified recipient(s). Recipient can make One-click approve/reject decision on email, or, approve/reject & comment on BoloForms Approvals website. Finally, an email will be sent to all recipients notifying the final result.",
  },
  {
    id: 4,
    title: "Does recipient need Google Account?",
    desc: "No. Recipients do not need Google account. They also do not need to have access to your Google Form or spreadsheet. When a request is sent, recipient will receive an email which includes: One-click Approve & One-click Reject button: to approve/reject immediately. Approve/Reject & Comment button: to open BoloForms Website where you can approve/reject & give comment on the request.",
  },
  {
    id: 5,
    title: "How many recipients can I add?",
    desc: "There is no limit to the number of recipients. However, be aware that the higher number of recipients is, the quicker your emails quota may run out.",
  },
  {
    id: 6,
    title: "Can Form Respondent or Recipients edit a form submission?",
    desc: "You can have option to allow Form Respondents to edit their own submission. However, Recipients can not edit submissions from Respondent.",
  },
  {
    id: 7,
    title: "What is the difference between email and request?",
    desc: "A request needs to send multiple emails to different recipients and respondent (optional) for approval. This means that one request may costs lots of email quota.      ",
  },
  {
    id: 8,
    title: "What will happen if I run out of email quota?",
    desc: "When you run out of email quota, the addon will temporary stop running. You will have to wait for quota renewal to send email again. If you are Free user, you can purchase Individual Plan and enjoy much higher quotas (at least 5000 emails/month) and unlimited emails sent per day.",
  },
  {
    id: 9,
    title: "What will happen to my data if I cancel my subscription?",
    desc: "You data will still be stored in our database even after your subscription cancellation. If you want to remove your data, please contact to us via support@boloforms.com.",
  },
  {
    id: 10,
    title: "I receive a permission error when I try to setup the Add-on",
    desc: "This is a known issue with Google permissions and it happens when you are logged in with more than one Google account. Try to sign out of all account except your main account. Alternatively, try Guest/Incognito mode.",
  },
  {
    id: 11,
    title:
      "Can I use the addon if my organisation does not use Google accounts?",
    desc: "Yes, but be aware that Form owner/adminstrator in particular still needs Google account. This is because the addon sends email on your Gmail behalf.",
  },
  {
    id: 12,
    title: "How can I contact support?",
    desc: "For any additional questions, you can contact us on support@boloforms.com or on WhatsApp at https://wa.me/message/MBQ5HUL53GQVK1 anytime.",
  },
  {
    id: 13,
    title:
      "Why does the approval workflow sometimes work smoothly and other times throws errors?",
    desc: "If you suddenly have an error running when using an add-on, please let us know by sending an email to support@boloforms.com. Our team will contact you as soon as possible to look into the issue. If you need an expedited support, feel free to message us on WhatsApp at https://wa.me/message/MBQ5HUL53GQVK1.",
  },
];

const Approvals = ({ refs }) => {
  const [currentSliderReviewIndex, setCurrentSliderReviewIndex] = useState(0);

  const handlePrevClick = () => {
    setCurrentSliderReviewIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentSliderReviewIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const slideInterval = setInterval(handleNextClick, 4000);
    return () => clearInterval(slideInterval);
  }, []);

  const [width] = useDeviceSize();

  const schema1 = {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    name: "Form Approval",
    url: "https://www.boloforms.com/form-approval/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.boloforms.com/form-approval/{search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const schema2 = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.boloforms.com",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Form Approval",
        item: "https://www.boloforms.com/form-approval/",
      },
    ],
  };

  const schema3 = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Boloforms",
    alternateName: "Form Approval",
    url: "https://www.boloforms.com/form-approval/",
    logo: "https://www.boloforms.com/_next/static/media/logo-text.e6f7617c.svg",
    sameAs: [
      "https://www.facebook.com/boloforms/",
      "https://twitter.com/BoloForms",
      "https://www.youtube.com/channel/UCjbA2sUd7jxdtiuwadt7VKg",
      "https://www.boloforms.com/form-approval/",
    ],
  };

  return (
    <div>
      <Head>
        <meta charSet="utf-8" />
        <title>
          How to create a Google Forms Approval Workflow - Boloforms
        </title>
        <meta
          name="description"
          content="How to create a Google Forms Approval Workflow? BoloForms has a great tutorial that shows you how to set up a system that will save you time."
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms " />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link rel="canonical" href="https://www.boloforms.com/form-approval/" />

        <meta
          property="og:url"
          content="https://www.boloforms.com/form-approval/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="How to create a Google Forms Approval Workflow - Boloforms"
        />
        <meta
          property="og:description"
          content="How to create a Google Forms Approval Workflow? BoloForms has a great tutorial that shows you how to set up a system that will save you time."
        />
        <meta
          property="og:image"
          content="https://www.boloforms.com/_next/static/media/logo-text.e6f7617c.svg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          property="twitter:url"
          content="https://www.boloforms.com/form-approval/"
        />
        <meta
          name="twitter:title"
          content="How to create a Google Forms Approval Workflow - Boloforms"
        />
        <meta
          name="twitter:description"
          content="How to create a Google Forms Approval Workflow? BoloForms has a great tutorial that shows you how to set up a system that will save you time."
        />
        <meta
          name="twitter:image"
          content="https://www.boloforms.com/_next/static/media/logo-text.e6f7617c.svg"
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema1) }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema2) }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema3) }}
        />
      </Head>

      <section className="relative">
        <Image
          className="absolute bottom-0 -z-20 w-full h-auto"
          width="10"
          height="10"
          alt="Element"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/shape-1.svg`}
        />
        <Image
          className="absolute left-0 top-[-100px] -z-10 w-auto h-auto"
          width="10"
          height="10"
          alt="Element"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-1.svg`}
        />
        <Image
          className="absolute right-0 top-[-20px] -z-10 w-auto h-auto"
          width="10"
          height="10"
          alt="Element"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-2.svg`}
        />
        <Image
          className="absolute left-0 bottom-0 -z-10 md:w-[250px] w-[150px] h-auto"
          width="10"
          height="10"
          alt="Element"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-5.svg`}
        />
        <Image
          className="absolute right-0 bottom-[-100px] -z-10 md:w-[500px] w-[200px] h-auto"
          width="10"
          height="10"
          alt="Element"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-6.svg`}
        />

        <div className="flex flex-col gap-y-[80px] lg:px-20 px-5 py-[50px]">
          {/* <div className="relative top-[-80px] self-center">
            <Image
              className="absolute left-[-80px] top-[30px] -z-10 max-w-[200px] sm:max-w-[300px]"
              alt="Element"
              src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-3.svg`}
            />
            <Image
              className="absolute sm:right-[-80px] right-0 bottom-[-30px] -z-10  max-w-[150px] sm:max-w-[250px]"
              alt="Element"
              src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-4.svg`}
            />
            <Image
              className="absolute right-0 top-[60px] -z-10 max-w-[50px] sm:max-w-[150px]"
              alt="Element"
              src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-7.svg`}
            />
            <Image
              className="max-w-[550px]"
              alt="Element"
              src={`${BASE_ASSETS_URL}/approvals/landing-page-images/heroLaptop.png`}
            />
            <Image
              className="absolute top-[100px]"
              alt="Element"
              src={`${BASE_ASSETS_URL}/approvals/landing-page-images/heroPeople.png`}
            />
          </div> */}

          <div className="flex items-center flex-col gap-[30px]">
            <h2 className="text-[40px] lg:text-[60px] lg:leading-[70px] text-center max-w-[1000px] font-bold text-black">
              Simplify Your Approval Process
            </h2>
            <p className="lg:text-[25px] text-[20px] text-gray-600 text-center max-w-[1200px]">
              Discover BoloForms, the Google Forms add-on that empowers you to
              incorporate conditional logic into your forms. With BoloForms, you
              can design dynamic workflows, streamline approval processes, and
              automate a variety of tasks.
            </p>
            <div className="flex gap-[10px]">
              <Link
                href="https://approval-docs.boloforms.com"
                target="_blank"
                className="flex font-semibold items-center justify-center w-[150px] py-2 bg-[#9C6CFF] rounded-full text-white hover:bg-[#aa81fc] transition-all duration-300 ease-in-out"
              >
                Watch Demo
              </Link>
              <Link
                href="https://approval-dashboard.boloforms.com"
                target="_blank"
                className="flex font-semibold items-center justify-center w-[150px] py-2 border-2 border-[#9C6CFF] rounded-full text-[#9C6CFF] hover:bg-[#a376fd] hover:text-white transition-all duration-300 ease-in-out"
              >
                Free Trial
              </Link>
            </div>
          </div>

          <div className="w-full flex justify-center items-center">
            <iframe
              className={`w-[560px] h-[315px] md:w-[460px] lg:w-[560px] border-4 rounded-2xl border-[#9a6afd]`}
              src={"https://www.youtube.com/embed/riiUkCRpIio"}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <section className="py-20 lg:px-20 px-5 mt-[10px] flex flex-col gap-y-10 items-center">
        <div className="max-w-fit">
          <div className="h-[5px] w-[50%] bg-violet-600 mx-auto mb-4 rounded-full"></div>
          <h2 className="text-[40px] md:text-[60px] lg:leading-[70px] text-center font-bold text-black">
            Our Customers
          </h2>
        </div>
        <Link
          style={{
            boxShadow:
              "rgb(0 0 0 / 4%) 0 1px 0, rgb(0 0 0 / 5%) 0 2px 7px, rgb(0 0 0 / 6%) 0 12px 22px",
          }}
          href="/customers"
          className="w-fit h-fit bg-white rounded-xl flex justify-center items-center p-5"
        >
          <Image
            alt="Our Customers"
            src={
              "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/our-customers.png"
            }
            loading="eager"
            width="1176"
            height="166"
          />
        </Link>
      </section>

      <section className="relative">
        <Image
          className="absolute right-0 top-[50px] -z-10 w-auto h-auto"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-8.svg`}
          width="10"
          height="10"
        />
        <Image
          className="absolute right-0 top-[100px] -z-10 w-auto h-auto"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-9.svg`}
          width="10"
          height="10"
        />
        <Image
          className="absolute right-0 top-[100px] -z-10"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-10.png`}
          width="10"
          height="10"
        />
        <Image
          className="absolute left-0 top-[400px] -z-20 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-1.svg`}
          width="10"
          height="10"
        />

        <div className="lg:px-20 px-5 py-7 flex flex-col md:gap-y-[80px] gap-y-[50px] md:mt-[50px]">
          <h2 className="text-[40px] md:text-[60px] lg:leading-[70px] text-center font-bold text-black">
            Why Choose BoloForms?
          </h2>
          <div className="flex flex-col md:gap-y-[100px] gap-y-[80px] z-10">
            {whyReasons?.map((reason) => {
              return (
                <div
                  key={reason?.id}
                  className={`flex ${
                    reason?.isImgFirst ? "flex-col-reverse" : "flex-col"
                  } sm:flex-row gap-x-[50px] gap-y-[30px] items-center justify-center`}
                >
                  {reason?.isImgFirst && (
                    <Image
                      style={{ filter: "drop-shadow(0px 0px 20px #cec5c5)" }}
                      className={`xl:w-[600px] md:w-[400px] sm:w-[300px] w-[400px] h-auto rounded-xl ${
                        reason?.id !== 1 && "border-2 border-gray-600"
                      }`}
                      alt="Reason"
                      src={`${BASE_ASSETS_URL}/approvals/landing-page-images/${reason?.image}`}
                      width="10"
                      height="10"
                    />
                  )}
                  <div className="flex flex-col gap-y-[20px] max-w-[600px]">
                    <p className="font-semibold text-black lg:text-[38px] text-[25px] lg:leading-[45px] leading-[30px]">
                      {reason?.title}
                    </p>
                    <p className="text-[20px]">{reason?.desc}</p>
                  </div>
                  {reason?.isImgFirst === false && (
                    <Image
                      style={{ filter: "drop-shadow(0px 0px 20px #cec5c5)" }}
                      className={`xl:w-[600px] md:w-[400px] sm:w-[300px] w-[400px] h-auto rounded-xl border-2 border-gray-600`}
                      alt="Reason"
                      src={`${BASE_ASSETS_URL}/approvals/landing-page-images/${reason?.image}`}
                      width="10"
                      height="10"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="relative">
        <Image
          className="absolute left-0 top-[-400px] -z-10 w-auto h-auto"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-11.png`}
          width="10"
          height="10"
        />
        <Image
          className="absolute right-0 top-[30%] -z-10 w-auto h-auto"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-12.png`}
          width="10"
          height="10"
        />
        <Image
          className="absolute left-0 bottom-[-300px] -z-10 w-auto h-auto"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-13.png`}
          width="10"
          height="10"
        />
        <Image
          className="absolute right-0 top-[-400px] -z-10 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-2.svg`}
          width="10"
          height="10"
        />
        <Image
          className="absolute left-0 top-[15%] -z-10 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-3.svg`}
          width="10"
          height="10"
        />
        <Image
          className="absolute left-0 top-[25%] -z-10 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-4.svg`}
          width="10"
          height="10"
        />
        <Image
          className="absolute left-0 top-[50%] -z-10 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-5.svg`}
          width="10"
          height="10"
        />

        <div className="lg:px-20 px-5 py-20 flex flex-col gap-y-[50px] md:mt-[50px]">
          <h2 className="text-[40px] md:text-[60px] lg:leading-[90px] text-center self-center font-bold text-black">
            How does BoloForms Approval work?
          </h2>
          <p className="font-semibold max-w-fit self-center leading-[50px] sm:mb-[40px] text-[#9058FF] md:text-[48px] text-[35px] text-center border-b-[4px] border-gray-800 rounded-md">
            Sender
          </p>
          <div className="flex flex-col gap-y-[80px]">
            {senderSteps?.map((singleStep) => {
              return (
                <div
                  key={singleStep?.id}
                  className={`flex ${
                    singleStep?.isImgFirst ? "flex-col-reverse" : "flex-col"
                  } sm:flex-row gap-x-[50px] gap-y-[30px] items-center justify-center`}
                >
                  {singleStep?.isImgFirst && (
                    <Image
                      style={{ filter: "drop-shadow(0px 0px 20px #cec5c5)" }}
                      className={`xl:w-[600px] md:w-[400px] sm:w-[300px] w-[400px] h-auto rounded-xl border-2 border-gray-600`}
                      alt="Sender Step"
                      src={`${BASE_ASSETS_URL}/approvals/landing-page-images/${singleStep?.image}`}
                      width="10"
                      height="10"
                    />
                  )}
                  <div className="flex flex-col md:gap-y-[20px] gap-y-[10px] max-w-[600px]">
                    <p className="font-semibold text-black lg:text-[35px] text-[25px] leading-[40px]">
                      <span className="text-[#8C52FF] font-semibold md:text-[40px] text-[30px]">
                        {singleStep?.id}.{" "}
                      </span>
                      {singleStep?.title}
                    </p>
                    <p className="text-[20px]">{singleStep?.desc}</p>
                  </div>
                  {singleStep?.isImgFirst === false && (
                    <Image
                      style={{ filter: "drop-shadow(0px 0px 20px #cec5c5)" }}
                      className={`xl:w-[600px] md:w-[400px] sm:w-[300px] w-[400px] h-auto rounded-xl border-2 border-gray-600`}
                      alt="Sender Step"
                      src={`${BASE_ASSETS_URL}/approvals/landing-page-images/${singleStep?.image}`}
                      width="10"
                      height="10"
                    />
                  )}
                </div>
              );
            })}
          </div>

          <p className="font-semibold max-w-fit self-center leading-[50px] sm:mb-[40px] text-[#9058FF] md:text-[48px] text-[35px] text-center border-b-[4px] border-gray-800 rounded-md md:pt-20 pt-10">
            Receiver
          </p>
          <div className="flex flex-col gap-y-[80px]">
            {receiverSteps?.map((singleStep) => {
              return (
                <div
                  key={singleStep?.id}
                  className={`flex ${
                    singleStep?.isImgFirst ? "flex-col-reverse" : "flex-col"
                  } sm:flex-row gap-x-[50px] gap-y-[30px] items-center justify-center`}
                >
                  {singleStep?.isImgFirst && (
                    <Image
                      style={{ filter: "drop-shadow(0px 0px 20px #cec5c5)" }}
                      className={`xl:w-[600px] md:w-[400px] sm:w-[300px] w-[400px] h-auto rounded-xl border-2 border-gray-600`}
                      alt="Receiver Step"
                      src={`${BASE_ASSETS_URL}/approvals/landing-page-images/${singleStep?.image}`}
                      width="10"
                      height="10"
                    />
                  )}
                  <div className="flex flex-col md:gap-y-[20px] gap-y-[10px] max-w-[600px]">
                    <p className="font-semibold text-black lg:text-[35px] text-[25px] leading-[40px]">
                      <span className="text-[#8C52FF] font-semibold md:text-[40px] text-[30px]">
                        {singleStep?.id}.{" "}
                      </span>
                      {singleStep?.title}
                    </p>
                    <p className="text-[20px]">{singleStep?.desc}</p>
                  </div>
                  {singleStep?.isImgFirst === false && (
                    <Image
                      style={{ filter: "drop-shadow(0px 0px 20px #cec5c5)" }}
                      className={`xl:w-[600px] md:w-[400px] sm:w-[300px] w-[400px] h-auto rounded-xl border-2 border-gray-600`}
                      alt="Receiver Step"
                      src={`${BASE_ASSETS_URL}/approvals/landing-page-images/${singleStep?.image}`}
                      width="10"
                      height="10"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="relative">
        <Image
          className="absolute left-0 top-0 -z-10 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-6.svg`}
          width="10"
          height="10"
        />

        <div className="lg:px-20 px-5 py-7 flex flex-col gap-y-[30px] md:mt-[50px]">
          <h2 className="text-[40px] md:text-[60px] lg:leading-[70px] text-center font-bold text-black">
            Features
          </h2>
          <p className="font-semibold text-black md:text-[30px] text-[23px] text-center">
            Experience Everything Your Organization Will Adore and Beyond.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 justify-items-center gap-[50px] w-full mt-[50px] mx-auto max-w-[1300px]">
            {features.map((feature) => {
              return (
                <div
                  key={feature?.id}
                  className="z-10 bg-white border-2 border-gray-600 flex min-h-[300px] max-w-[350px] flex-col p-[40px] gap-[10px] w-full shadow-lg rounded-[40px] hover:scale-[1.1] transition ease-in-out duration-300"
                >
                  <div className="w-fit text-[50px] rounded-full text-violet-600 grid place-items-center">
                    {feature?.icon}
                  </div>
                  <p className="font-bold text-[20px]">{feature?.title}</p>
                  <p className="text-gray-600">{feature?.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="lg:px-20 px-5 py-7 flex flex-col md:gap-y-[10px] md:mt-[100px] bg-[#bc9affbf] mt-[50px]">
        <h2 className="text-[40px] md:text-[60px] lg:leading-[70px] text-center font-bold text-black">
          Testimonials
        </h2>
        <div className="flex self-center gap-x-[20px] w-full xxl:max-w-[1400px] lg:h-[320px] xs:h-[500px] h-auto items-center justify-center">
          <span
            onClick={handlePrevClick}
            className="flex items-center cursor-pointer"
          >
            <BsChevronLeft className="text-3xl" />
          </span>
          <div
            className={
              "my-12 w-full flex sm:flex-row flex-col gap-y-[20px] items-center py-2 sm:p-10 rounded-3xl bg-gray-50 border-2 border-violet-500"
            }
          >
            <div
              className={
                "h-16 w-16 sm:h-32 sm:w-32 rounded-full overflow-hidden"
              }
            >
              <Image
                className={"h-full w-full object-cover"}
                src={`${BASE_ASSETS_URL}/approvals/reviewers/${reviews[currentSliderReviewIndex]?.image}`}
                width="10"
                height="10"
                alt="Customer Image"
                loading="lazy"
              />
            </div>
            <div
              style={{
                width: `calc(100% - ${width > 640 ? "128px" : "64px"})`,
              }}
              className={"sm:pl-12"}
            >
              <div className={"h-6 mb-4"}>
                <Image
                  className={"w-32 h-full"}
                  src={`${BASE_ASSETS_URL}/Stars.svg`}
                  width="10"
                  height="10"
                  alt="Stars"
                  loading="lazy"
                />
              </div>
              <p
                className={"mb-2 text-sm sm:text-base"}
              >{`"${reviews[currentSliderReviewIndex]?.review}"`}</p>
              <h3 className={"text-base sm:text-lg font-semibold"}>
                {reviews[currentSliderReviewIndex]?.name}
              </h3>
            </div>
          </div>

          <span
            onClick={handleNextClick}
            className="flex items-center cursor-pointer"
          >
            <BsChevronRight className="text-3xl" />
          </span>
        </div>
      </section>

      <section className="relative">
        <Image
          className="absolute left-0 top-[-500px] -z-10 w-auto h-auto"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/ellipse-14.png`}
          width="10"
          height="10"
        />
        <Image
          className="absolute left-0 top-[-100px] -z-10 w-auto h-auto opacity-40"
          alt="Element"
          loading="lazy"
          src={`${BASE_ASSETS_URL}/approvals/landing-page-images/line-7.svg`}
          width="10"
          height="10"
        />

        <div className="lg:px-20 px-5 pt-7 pb-0 md:mt-[50px] mt-[20px]">
          <SupportSec />
        </div>
      </section>

      <section className="lg:px-20 px-5 py-14 flex items-center flex-col gap-y-[30px] bg-[#8c52ffb3] md:mt-[60px] mt-[30px]">
        <h2 className="text-[30px] lg:text-[50px] lg:leading-[70px] text-center font-bold text-white">
          Create Approvals with BoloForms
        </h2>
        <Link
          href="https://approval-dashboard.boloforms.com"
          target="_blank"
          className="text-white text-[25px] text-center border-[2.5px] rounded-lg border-white sm:px-16 px-10 py-2 hover:bg-white hover:text-[#7531fdb3] transition-all duration-300 ease-in-out"
        >
          Try For Free
        </Link>
      </section>

      <section className="lg:px-20 px-5 pt-7 flex flex-col gap-y-[50px] mt-[10px]">
        <FAQ faqs={faqs} />
      </section>
    </div>
  );
};

export default Approvals;
